/* eslint-disable */
//styles
import "../../src/styles/App.css";
import Logo from "../styles/img/header.svg";

//Components
import Header from "../Components/Common/header";
import Card from "../Components/Card";
import ProgressBar from "../Components/ProgressBar";

//react
import { useEffect, useState } from "react";

//redux
import { scanToken } from "../lib/slices/paladin";
import { store } from "../lib/store";

//hooks
import RoundLoader from "../Hooks/RoudLoader";

//libs
import { datadogLogs } from "@datadog/browser-logs";
import { MdCancel } from "react-icons/md";

//Components
import InvitationFail from "../Components/InvitationFail";

//Utils
import { isVerifiedMobileDevice } from "../Utils/deviceValidation";

const Setup = () => {
    const [loading, setLoading] = useState(false);
    const { dispatch } = store;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get("token");
    const [responseScan, setResponseScan] = useState(null);
    const [tenantColor, setTenantColor] = useState(localStorage.getItem(`tenantColor_${token}`) || "#6A2ABD");
    const [tenantImage, setTenantImage] = useState(Logo);
    const [tenantName, setTenantName] = useState("");
    const [completionPercentage, setCompletionPercentage] = useState(0);

    const queryData = async () => {
        setLoading(true);
        var data = { token };

        try {
            const response = await dispatch(scanToken({ data }));
            setResponseScan(response?.payload?.ScanToken);
            const resolvedColor = response?.payload?.ScanToken?.custom_color || "#6A2ABD";
            setTenantColor(resolvedColor);
            localStorage.setItem(`tenantColor_${token}`, resolvedColor);
            setTenantImage(
                response?.payload?.ScanToken?.custom_image &&
                `data:image/jpeg;base64,${response?.payload?.ScanToken?.custom_image}`
            );
            setTenantName(
                response?.payload?.ScanToken?.account_name
                    ? response?.payload?.ScanToken?.account_name
                    : ""
            );
            const totalSteps = response?.payload?.ScanToken?.flow_steps?.length || 0;
            const completeSteps =
                response?.payload?.ScanToken?.flow_steps?.filter(
                    (step) => step.isFinished === true
                ).length || 0;
            setCompletionPercentage((completeSteps / totalSteps) * 100);

            datadogLogs.logger.log("Token validated (setup)", {
                category: "token-validation",
                status: "info",
                tenantName: response?.payload?.ScanToken?.account_name,
            });
        } catch (error) {
            datadogLogs.logger.log("Error validating token (setup)", {
                category: "error-handling",
                status: "error",
                token: token,
            });

            datadogLogs.logger.log("Error validating token (App) - additional data", {
                category: "error-handling",
                status: "info",
                token: token,
                errorMessage: error?.message,
            });

            datadogLogs.logger.log("Exception occurred during token validation", {
                status: "error",
                errorMessage: error?.message,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        queryData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {loading ? (
                <main className="flex flex-col gap-8 h-screen row-start-2 items-center justify-center w-full container mx-auto p-3 py-6">
                    <RoundLoader loading={loading} color={tenantColor} />
                </main>
            ) : (
                <>
                    {responseScan?.invitation_id && (
                        <>
                            {isVerifiedMobileDevice() ? (
                                <main className="flex flex-col gap-8 row-start-2 items-center justify-start w-full container mx-auto p-3 py-6">
                                    <Header tenantImage={tenantImage} tenantName={tenantName} />
                                    <section className="w-full flex flex-col gap-6">
                                        <ProgressBar
                                            progress={completionPercentage}
                                            tenantColor={tenantColor}
                                        />
                                        <div className=" max-h-[490px] overflow-y-auto w-full flex flex-col gap-3">
                                            {responseScan?.flow_steps?.map((item, index) => (
                                                <div key={index} className="w-full ">
                                                    <Card
                                                        tenantColor={tenantColor}
                                                        enabled={item?.is_enabled}
                                                        name={item?.step_name}
                                                        description={item?.step_description}
                                                        image={item?.step_image}
                                                        slug={item?.step_slug}
                                                        finished={item?.isFinished}
                                                    />
                                                </div>
                                            ))}

                                            {responseScan?.error && <InvitationFail />}
                                        </div>
                                    </section>
                                </main>
                            ) : (
                                <div className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
                                    <MdCancel size={150} className="text-[#E43122]" />
                                    <h2 className="text-2xl text-[#E43122]">Error</h2>
                                    <p className="my-5 text-center text-sm">
                                        PALIDIN WebID is not available for desktop computers.{" "}
                                        <br></br>
                                        Please open the authentication invitation on a mobile
                                        device.
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                    {(responseScan?.error || token === null) && <InvitationFail />}
                </>
            )}
        </>
    );
};

export default Setup;
